import ManagedAccordionSection from "@eisinc/MobiusOverrides/AccordionSection/ManagedAccordionSection";

export default ManagedAccordionSection;

export * from "./ManagedAccordionSection";
